module.exports = __webpack_public_path__ + "img/inventory_problem.f8b21438.svg";